$(document).ready(function() {
  document.cookie = 'brand=Alfa Romeo' + ';path=/';
  document.cookie = 'model=None' + ';path=/';
  document.cookie = 'grade=None' + ';path=/';
  document.cookie = 'catalogType=None' + ';path=/';

  $('#brand').on('change', function() {
    document.cookie = 'brand=' + $(this).val() + ';path=/';
  });

  $('#model').on('change', function() {
    document.cookie = 'model=' + $(this).val() + ';path=/';
  });

  // $('#grade').on('change', function() {
  //   document.cookie = 'grade=' + $(this).val() + ';path=/';
  // });

  $('input[type=radio][name=catalogType]').on('change', function() {
    switch ($(this).val()) {
      case '郵送':
        document.cookie = 'catalogType=郵送' + ';path=/';
        break;
      case 'PDF':
        document.cookie = 'catalogType=PDF' + ';path=/';
        break;
    }
  });

  $(window).on('load', function () {
    var catalogTypeChecked = $('input[name=catalogType]:checked').val();
    switch (catalogTypeChecked) {
      case '郵送':
        document.cookie = 'catalogType=郵送' + ';path=/';
        break;
      case 'PDF':
        document.cookie = 'catalogType=PDF' + ';path=/';
        break;
      default:
        document.cookie = 'catalogType=None' + ';path=/';
      }
  });
});
